import { TrafficRule } from '@thive/fddm-types';
import { DoNotStopRule, RestrictedAccessRule, SpeedLimitRule, VehicleModeRule } from './types';



export const isSpeedLimit = (rule: TrafficRule): rule is SpeedLimitRule =>
  rule.type === 'SPEED_LIMIT' && rule.speedLimitExtension !== null;

export const isVehicleMode = (rule: TrafficRule): rule is VehicleModeRule =>
  rule.type === 'VEHICLE_MODE' && rule.vehicleModeExtension !== null;

export const isDoNotStop = (rule: TrafficRule): rule is DoNotStopRule =>
  rule.type === 'DO_NOT_STOP';

export const isRestrictedAccess = (rule: TrafficRule): rule is RestrictedAccessRule =>
  rule.type === 'RESTRICTED_ACCESS';
